import React from "react";
import { Link } from "react-router-dom";
import {
  FaCommentDots,
  FaExternalLinkAlt,
  FaEnvelope,
  FaHome,
} from "react-icons/fa";

const Feedback = () => {
  return (
    <>
      <div className="top-bar"></div>
      <section lang="en" style={{ padding: "1rem 1.25rem", lineHeight: 1.6 }}>
        <header style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FaCommentDots aria-hidden="true" />
          <h2 style={{ margin: 0 }}>Feedback</h2>
        </header>

        <p style={{ marginTop: 12 }}>
          Have an idea, found a bug, or want to share feedback about RAD Tool?
          Pick an option below. We appreciate your input.
        </p>

        <ul style={{ paddingLeft: 18 }}>
          <li>
            Open an issue on GitHub:{" "}
            <a
              href="https://github.com/MichaelSScott/riva_bpm/issues/new/choose"
              target="_blank"
              rel="noreferrer noopener"
            >
              New Issue{" "}
              <FaExternalLinkAlt
                className="cs-icon"
                style={{ verticalAlign: "text-bottom" }}
              />
            </a>
          </li>
          <li>
            Send an email:{" "}
            <a href="mailto:your.email@example.com?subject=RAD%20Tool%20Feedback">
              your.email@example.com{" "}
              <FaEnvelope
                className="cs-icon"
                style={{ verticalAlign: "text-bottom" }}
              />
            </a>
          </li>
        </ul>

        <hr style={{ margin: "1rem 0" }} />

        <p>
          <Link to="/" className="actionButton" aria-label="Back to Home">
            <FaHome className="cs-big-icon" />
          </Link>
        </p>
      </section>
    </>
  );
};

export default Feedback;
